import { Check, ChevronRight } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from '@design-system/Sheet.tsx';

interface L4CardProps {
  title: string;
  description: string;
  'data-testid'?: string;
}

export const L4Card = ({ title, description, 'data-testid': testId }: L4CardProps) => {
  return (
    <Sheet data-testid={testId}>
      <SheetTrigger data-testid="l4Card-trigger">
        <div className="bg-white rounded-xl p-4 flex items-center justify-between w-full" data-testid="l4Card-container">
          <div className="flex items-center gap-3" data-testid="l4Card-content">
            <div className="w-5 h-5 rounded-full bg-background-success flex items-center justify-center" data-testid="l4Card-checkIcon">
              <Check className="w-3 h-3 text-white" data-testid="l4Card-check" />
            </div>
            <span className="typography-body text-primary line-clamp-1 text-start" data-testid="l4Card-title">
              {title}
            </span>
          </div>
          <ChevronRight className="w-5 h-5 text-primary" data-testid="l4Card-chevron" />
        </div>
      </SheetTrigger>
      <SheetContent data-testid="l4Card-sheet">
        <SheetHeader data-testid="l4Card-sheetHeader">
          <SheetTitle className='text-primary typography-h1 px-6' data-testid="l4Card-sheetTitle">
            {title}
          </SheetTitle>
          <SheetDescription className='typography-body text-secondary' data-testid="l4Card-sheetDescription">
            {description}
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};